import {
  ExternalPayerType as DomainExternalPayerType,
} from 'application-types';
import {
  ExternalPayerType,
} from 'graphql-query-contracts';

/**
 * Convert domain ExternalPayerType to GraphQL ExternalPayerType enum.
 * Maps from domain enum (EXTERNAL_PAYER_TYPE_ACTIVATE_USER) to GraphQL enum (ExternalPayerTypeActivateUser).
 */
export function convertExternalPayerType(
  domainType: DomainExternalPayerType
): ExternalPayerType {
  switch (domainType) {
    case DomainExternalPayerType.EXTERNAL_PAYER_TYPE_ACTIVATE_USER:
      return ExternalPayerType.ExternalPayerTypeActivateUser;
    case DomainExternalPayerType.EXTERNAL_PAYER_TYPE_ACTIVATE_COMPANY:
      return ExternalPayerType.ExternalPayerTypeActivateCompany;
    case DomainExternalPayerType.EXTERNAL_PAYER_TYPE_UNKNOWN:
    default:
      return ExternalPayerType.ExternalPayerTypeUnknown;
  }
}

